module.exports = __webpack_public_path__ + "fonts/AftaSansThin-Regular.bdad4798.ttf";